import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { LayoutDirective, LayoutAlignDirective } from '@ngbracket/ngx-layout/flex';

@Component({
    selector: 'app-maes-diogelwch-teiar-flex',
    templateUrl: './maes-diogelwch-teiar-flex.component.html',
    styleUrls: ['./maes-diogelwch-teiar-flex.component.scss'],
    imports: [LayoutDirective, LayoutAlignDirective, FormlyModule]
})
export class MaesDiogelwchTeiarFlexComponent extends FieldType<FieldTypeConfig> {
}
